import { render, staticRenderFns } from "./RemediationDashboard.vue?vue&type=template&id=4fce42cc&scoped=true"
import script from "./RemediationDashboard.vue?vue&type=script&lang=js"
export * from "./RemediationDashboard.vue?vue&type=script&lang=js"
import style0 from "./RemediationDashboard.vue?vue&type=style&index=0&id=4fce42cc&prod&scoped=true&lang=css"
import style1 from "./RemediationDashboard.vue?vue&type=style&index=1&id=4fce42cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fce42cc",
  null
  
)

export default component.exports